import { Place } from "../hooks/V2/useFinder";

const getPlaceFromId = async (placeId: string, country: string, language: string) => {
  const searchParams = new URLSearchParams({
    country: country as string,
    language: language as string,
    placeId
  });

  const placeResponse = await fetch(`/api/location-details?${searchParams.toString()}`);
  if (placeResponse.status >= 400) {
    throw new Error("Failed to fetch place.");
  }

  const placeJson: Place = await placeResponse.json();

  return placeJson;
};

export default getPlaceFromId;
